module.exports = __webpack_public_path__ + "static/media/revenueActive.b83ac433.svg";